// extracted by mini-css-extract-plugin
module.exports = {"container":"StatCard_container__9OWd9","left":"StatCard_left__guSUd","right":"StatCard_right__ESFaP","delimiter":"StatCard_delimiter__Wcf_b"};